import type { ReactNode } from "react"
import Badge from "@/v2-backoffice-client/components/badge"

export type LicenseSeatBadgeProps = {
  /** Occupied seats: active users + open invitations. */
  occupied: number
  /** Licensed seat cap; null/undefined = uncapped. */
  cap: number | null | undefined
  /** Richer tooltip content; the plain over-cap line is the default. */
  tooltip?: ReactNode
  className?: string
}

// The ONE rendering of "occupied / cap" seat pressure — the customer header,
// the customers board and the licenses board all compose this, so the same
// situation can never wear two colors. Over-cap is amber (a billing
// conversation, not breakage — red is reserved for broken plumbing like
// unmapped licenses and unmatched accounts); uncapped shows an em-dash cap.
// The people icon is what tells "4 / 3" apart from an amber trial pill at a
// glance: same hue, different shape (see getLicenseStatusVisual).
function LicenseSeatBadge(props: LicenseSeatBadgeProps) {
  const { occupied, cap, tooltip, className } = props

  const isOver = cap != null && occupied > cap

  return (
    <Badge
      className={className}
      variant={isOver ? "warning" : "neutral"}
      iconSrc="users"
      tooltip={
        tooltip ?? (isOver ? "More seats occupied than licensed" : undefined)
      }
    >
      {occupied} / {cap ?? "—"}
    </Badge>
  )
}

export default LicenseSeatBadge
